const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  enableDebugMode: import.meta.env.VITE_ENABLE_DEBUG_MODE ? import.meta.env.VITE_ENABLE_DEBUG_MODE !== 'false' : import.meta.env.MODE === 'development',
}
export default config
